import { getColorScheme } from "@appally/lib/utils/colorSchemes";
import { tabsAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(tabsAnatomy.keys);

const solid = definePartsStyle((props) => {
  const { main, light, text } = getColorScheme(props.colorScheme);
  return {
    root: {
      color: text,
    },
    indicator: {
      bg: main,
      mt: "-1.5px",
      height: "4px",
    },
    tab: {
      color: main,
    },
  };
});

const enclosed = definePartsStyle((props) => {
  const { main, light, text } = getColorScheme(props.colorScheme);
  return {
    root: {
      color: text,
    },
    tablist: {
      py: 0,
    },
    tab: {
      color: main,
      borderColor: "transparent",
      borderBottomColor: "teal.500",
      _selected: {
        borderColor: main,
        borderBottomColor: "transparent",
      },
    },
    indicator: { display: "none" },
  };
});

const gradient = definePartsStyle((props) => {
  const { main, light, text, tint } = getColorScheme(props.colorScheme);
  return {
    root: {
      color: text,
    },
    indicator: {
      display: "none",
      // height: "10px",
      // mt: "-2px",
      // rounded: "full",
      // bgGradient: `linear(to-r, ${tint}, ${main})`,
    },
    tab: {
      color: main,
    },
  };
});

const cards = definePartsStyle((props) => {
  const { main, light, text, tint } = getColorScheme(props.colorScheme);
  return {
    root: {
      color: main,
    },
    indicator: {
      display: "none",
      // height: "10px",
      // mt: "-2px",
      // rounded: "full",
      // bgGradient: `linear(to-r, ${tint}, ${main})`,
    },
    tablist: {
      display: "grid",
      width: "100%",
      gridTemplateColumns: "repeat(4, minmax(100px, 1fr))",
      gap: 4,
    },
    tab: {
      bg: "white",
      rounded: "xl",
      p: 0,
      as: "div",
      cursor: "pointer",
      transition: "all 0.2s",
      _selected: {
        shadow: "md",
      },
    },
  };
});

export const Tabs = defineMultiStyleConfig({
  baseStyle: (props) => ({
    root: {
      position: "relative",
    },
    tablist: {
      width: "100%",
      py: 2,
    },
    tab: {
      fontWeight: "semibold",
    },
  }),
  variants: { solid, gradient, cards, enclosed },
  defaultProps: {
    size: "md",
    variant: "solid",
    colorScheme: "secondary",
  },
});
